export default __webpack_public_path__ + "static/media/pdf.eba3a8f8.svg";